'use client';

import Image from 'next/image';
import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FeatureHero from '../_shared/sections/FeatureHero';

type Props = { lang: Locale };

const HERO_IMAGE = 'https://cdn.1cdn.app/application/UMD/26050415064353_event_sum.png';

const EventManagementHero = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const trust = t('EventManagement/Hero/trust', { returnObjects: true }) as string[] | string;

  const visual = (
    <Image
      src={HERO_IMAGE}
      alt={t('EventManagement/Hero/image_alt')}
      width={840}
      height={840}
      sizes="(min-width: 1024px) 220px, 50vw"
      className="mx-auto h-auto w-1/2 max-w-[180px] rounded-2xl lg:w-full lg:max-w-[220px]"
      priority
    />
  );

  return (
    <FeatureHero
      accent="#22D3EE"
      ariaLabel={t('EventManagement/Hero/aria_label')}
      copy={{
        kicker: t('EventManagement/Hero/badge'),
        headlineA: t('EventManagement/Hero/title1'),
        headlineB: t('EventManagement/Hero/title2'),
        subhead: t('EventManagement/Hero/subtitle'),
        ctaPrimary: {
          label: t('EventManagement/Hero/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('EventManagement/Hero/cta_secondary'),
          href: '#how-it-works',
        },
        trust: Array.isArray(trust) ? trust : undefined,
      }}
      visual={visual}
      visualVisibleOnMobile
    />
  );
};

export default EventManagementHero;
